'use client';

import {styled} from '@mui/material/styles';
import NextLink from 'next/link';
import {LINK_FONT_SIZE, linkShouldForwardProp, type LinkBaseProps} from './link-base';
import {Typography} from './Typography';

export type FooterLinkProps = LinkBaseProps;

const Root = styled(NextLink, {shouldForwardProp: linkShouldForwardProp})(({theme}) => ({
  color: theme.palette.colors.text.neutral.inverseMuted,
  textDecoration: 'none',
  '&:hover': {color: theme.palette.colors.text.neutral.inverse},
}));

export function FooterLink({size = 'lg', children, ...rest}: FooterLinkProps) {
  return (
    <Root {...rest}>
      <Typography
        as="span"
        family="primary"
        size={LINK_FONT_SIZE[size]}
        weight="regular"
        lineHeight={size === 'lg' ? '22' : undefined}
        sx={{color: 'inherit'}}
      >
        {children}
      </Typography>
    </Root>
  );
}

FooterLink.displayName = 'FooterLink';
